<template>
  <div class="scroller">
    <div class="list">
      <div class="list__heading">
        <h2>Categories</h2>
        <router-link :to="{ name: 'categories.create'}" class="btn btn--primary btn--small">
            NEW CATEGORY
        </router-link>
      </div>

      <Loader v-if="isLoading" />
      <CategoryItem v-for="category in categoriesTree" :category="category" :key="category.id" v-else/>
    </div>
  </div>
</template>

<script>
import * as types from '@/store/types.js'
import Category from '@/model/Category'
import CategoryItem from './CategoryItem'
import Loader from '@/components/Utils/Loader'
import {loadResource} from '@/helpers/resource'

export default {
  computed: {
    categories () {
      return this.$store.getters[types.ALL_CATEGORIES]
    },
    categoriesTree () {
      return this.$store.getters[types.ALL_CATEGORIES_TREE]
    },
    isLoading () {
      return this.$store.getters[types.IS_LOADING_CATEGORIES]
    }
  },
  components: {
    CategoryItem, Loader
  },
  mounted () {
    loadResource(Category, types.GET_ALL_CATEGORIES, types.IS_LOADING_CATEGORIES, {all_languages: true})
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Category/CategoriesList.vue